<template>
      <v-btn-toggle
        class="test-toggle-component"
        @change="switchResult($event)"
        dense
        rounded
        outlined
      >
        <v-btn 
          v-for="(btn, index) of buttons"
          :key="btn.status || index"
          width="100px"
          outlined
          :class="
            isSelect == index
              ? 'btn-selected text-subtitle-2 '
              : 'btn-default text-subtitle-2'
          "
          :disabled="btn.disable"
        >
         {{btn.status}}
        </v-btn>
          </v-btn-toggle>
</template>
<script>
export default {
  name: 'TestToggle',
  props: {
    isSelect: {
      type: Number,
      required: true,
    },
    buttons: {
      type: Array,
      required: true
    }
  },
  methods: {
    switchResult(event){
     if(event == undefined){
      return 
     }
     this.isSelect = event
     this.$emit('testChange', event,)
    }
  }
}
</script>
<style scoped>
.test-toggle-component {
  margin-right: 24px;
  max-width: calc(100vw - 48px);
}
</style>
